<div class="stepper-header">
  <div class="stepper-progress">
    <div class="upper-section">
      <button *ngIf="isMobile" type="button" mat-icon-button (click)="goBack()"><mat-icon>arrow_back_ios</mat-icon></button>
      <div class="progress-track">
        <div class="progress-fill" [style.width.%]="overallProgress.progressPercentage"></div>

        <div class="progress-circle-1 completed"></div>

        <div class="progress-circle-2" [ngClass]="{
             'completed': overallProgress.progressPercentage >= 50,
             'near-completed': overallProgress.progressPercentage >= 45 && overallProgress.progressPercentage < 50,
             'incomplete': overallProgress.progressPercentage < 45
           }"></div>

        <div class="progress-circle-3" [ngClass]="{
             'completed': overallProgress.progressPercentage === 100,
             'near-completed': overallProgress.progressPercentage >= 95 && overallProgress.progressPercentage < 100,
             'incomplete': overallProgress.progressPercentage < 95
           }"></div>
      </div>

      <img *ngIf="isMobile" src="/assets/images/new_saf/saf_language.svg" alt="lang_icon" class="vector-1"
        (click)="triggerSelect()">
      <select #langSelect *ngIf="isMobile" (change)="onLanguageChange($event.target.value)" [(ngModel)]="selectedLang">
        <option *ngFor="let lang of supportedLang" [value]="lang.key">
          {{ lang.label }}
        </option>
      </select>
    </div>

    <div class="stepper-title" [attr.lang]="selectedLang">
      <p>{{title ? title : "Let's get you started" }}</p>
    </div>
  </div>

  <img src="/assets/images/new_saf/saf_vector_1.png" alt="shape" class="vector-1">
  <img src="/assets/images/new_saf/saf_vector_2.png" alt="shape" class="vector-2">
</div>
